// Planning table constants
export const STAGE_ORDER = ["Setup", "Application/Assessment", "Harvest", "Report", "Closed"];

export const STATUS_COLOR_MAP = {
  "done": "bg-green-400/50",
  "this week": "bg-blue-800/70",
  "this or next week": "bg-blue-400/50",
  "maybe next week": "bg-yellow-400/50",
  "decision needed": "bg-pink-400/50",
  "pi attention": "bg-purple-400/50",
  "if set up": "bg-sky-300/50",
  "urgent": "bg-red-500/80",
  "none": "bg-none",
};

export const DEFAULT_PAGINATION = {
  pageIndex: 0,
  pageSize: 10,
};

export const PAGE_SIZE_OPTIONS = [10, 20, 30, 50, 100];

// Default data fallback
export const DEFAULT_DATA = [];
